import { Group } from '@models/entities';

/**
 * Builds the list of groups that can be selected based on a dashboard configuration.
 * @param config The dashboard configuration.
 * @param groups The global list of groups.
 * @returns The list of groups that can be selected.
 */
export function buildGroupList(config: { types: string[], groupGuids: string[] }, groups: Group[]): { key: string; value: string; group: Group; }[] {
    const { groupGuids, types } = config;
    let groupList = (groups?.filter(g => types.indexOf(g.type) >= 0) || []);
    if (groupGuids && groupGuids.length && groups) {
        const existingGuids = groupList.map(d => d.guid);
        groupList = groupList.concat(groupGuids.filter(guid => existingGuids.indexOf(guid) < 0).map(guid => groups.filter(g => g.guid === guid)[0]));
    }
    const ref = groupList
        .sort((a, b) => a.uniqueName > b.uniqueName ? 1 : -1)
        .map(d => { return { key: d.guid, value: d.uniqueName, group: d }; });
    return ref;
}